import { NormalizedNumber, Percentage } from '@sparkdotfi/common-universal'

import { formatPercentage } from '@/domain/common/format'
import { Token } from '@/domain/types/Token'
import { HorizontalScroll } from '@/ui/atoms/horizontal-scroll/HorizontalScroll'

export interface TransactionOverviewFarmApyProps {
  apy: Percentage
  rewardsPerYear: NormalizedNumber
  rewardToken: Token
  apyDataTestId?: string
  rewardsPerYearDataTestId?: string
}

export function TransactionOverviewApyWithRewards({
  apy,
  rewardsPerYear,
  rewardToken,
  apyDataTestId,
  rewardsPerYearDataTestId,
}: TransactionOverviewFarmApyProps) {
  return (
    <HorizontalScroll>
      <div className="flex h-[18px] items-baseline gap-2">
        {apy.gt(0) && (
          <div data-testid={apyDataTestId} className="typography-label-2 text-primary">
            {formatPercentage(apy)}
          </div>
        )}
        <div className="typography-body-4 text-secondary" data-testid={rewardsPerYearDataTestId}>
          Earn ~{rewardToken.format(rewardsPerYear, { style: 'auto' })} {rewardToken.symbol}/year
        </div>
      </div>
    </HorizontalScroll>
  )
}
